module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_brunch-bb6c0790da7a5523a359fa16e10c9578.jpg";